import { Injectable } from '@angular/core';
import { SmmService } from './smm.service';
import { HttpClient } from '@angular/common/http';
import { ServiceConfig } from './service-config';
@Injectable()
export class SmmGroupService {
  private host = ServiceConfig.host;
  private data: any;
  private baseUrl = this.host + '/api/ipcc/';
  constructor(
    private smmService: SmmService , private http: HttpClient) {
      this.data = JSON.parse(localStorage.getItem('currentSmmData'));
  }

  public searchGroupByIdOrLink(from, size, id) {
    const body = {
      from: from,
      size: size,
      filter: {
      }
    };

    const idPattern = '^[0-9]+$';
    if (id.toLowerCase().match(idPattern) !== null) {
      body.filter['id'] = id;
    } else {
      if (id.indexOf('https://') > -1) {
        if (id.indexOf('?') > -1) {
          const temp = id.split('?');
          id = temp[0];
        }
        body.filter['link'] = id;
      } else {
        body.filter['username'] = id;
      }
    }
    return this.smmService.getGroups(body);
  }

  public searchGroups(from, size, bool, orderBy) {
    const body = {
      size: size,
      from: from,
      orderBy: orderBy,
      filter: bool
    };
    console.log(body);
    return this.smmService.getGroups(body);
  }

  public removePriority(body) {
    let url = this.baseUrl + '/group/removePriority?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getListGroupPriority(body) {
    return this.smmService.getListGroupPriority(body);
  }

  public getGroupById(id) {
    return this.smmService.getGroupById(id);
  }

  public getGroup(groupId) {
    let url = this.baseUrl + 'group/getGroup/'+ groupId + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/smm-group.service.ts